import * as React from 'react';
import { cx } from '../utils';
import type { StyledProps, WithChildren } from '../types';
import type { UnsafeStyleProps } from '../escape-hatches';

export interface BulkActionBarProps extends StyledProps, WithChildren, UnsafeStyleProps {
  count: number;
  onClear?: () => void;
}

export function BulkActionBar({
  count,
  onClear,
  children,
  className,
  unsafe_style,
}: BulkActionBarProps) {
  if (!count || count <= 0) return null;
  return (
    <div
      className={cx('j-bulk-bar', className)}
      role="toolbar"
      aria-label={`${count} items selected`}
      style={unsafe_style}
    >
      <span className="j-bulk-bar-count">{count} selected</span>
      <button
        type="button"
        className="j-bulk-bar-clear"
        onClick={onClear}
        aria-label="Clear selection"
      >
        Clear
      </button>
      <div className="j-bulk-bar-spacer" />
      <div className="j-bulk-bar-actions">{children}</div>
    </div>
  );
}
